import { render } from "./VPATable.vue?vue&type=template&id=5f80d032&scoped=true"
import script from "./VPATable.vue?vue&type=script&lang=js"
export * from "./VPATable.vue?vue&type=script&lang=js"

import "./VPATable.vue?vue&type=style&index=0&id=5f80d032&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f80d032"]])

export default __exports__